<section class="section" *ngIf="statusCode == 0">
    <div class="container">
        <div class="row align-items-center mb-3">
            <div class="col-auto">
                <h3 class="heading">{{ "HOME.LATEST-VIDEOS" | translate }}</h3>
            </div>
            <div class="col-auto ml-auto">
                <div class="see-more">
                    <a [routerLink]="['/videos']"
                        >{{ "GENERAL.VIEW-MORE" | translate }} <fa-icon [icon]="icons.arrowRight"></fa-icon
                    ></a>
                </div>
            </div>
        </div>

        <div *ngIf="statusCode == 0" class="row">
            <div class="col-lg-4 mb-4" *ngFor="let news of registers">
                <div class="video-card">
                    <img class="video-image" [src]="news.videos[0].url_capa" [alt]="news.title" />
                    <h3 class="video-title">
                        <span>{{ news.title }}</span>

                        <nb-icon icon="diagonal-arrow-right-up-outline"></nb-icon>
                    </h3>
                    <a
                        class="video-link"
                        [href]="news.videos[0].url_video"
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                </div>
            </div>
        </div>
    </div>
</section>
